import { Trans } from '@lingui/react/macro';
import { Box, Button, RadioCard, Typography } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { useGetLinks } from 'shared/domains/urls';
import { getLockedReasonMessage } from './utils';
import { ReasonContainer } from './styled';
export function OptionCheckbox(props) {
    const { title, type, lockedReason, pleditorDownloadUnavailable } = props;
    const { values, setFieldValue, errors } = useFormikContext();
    const { downloadType } = values;
    const disabled = pleditorDownloadUnavailable || lockedReason !== undefined;
    const { contact } = useGetLinks();
    const handleChange = () => {
        setFieldValue('downloadType', type);
    };
    return (<Box flexDirection="column" width="100%" gap="md">
      <RadioCard size="small" title={title} checked={type === downloadType} disabled={disabled} invalid={Boolean(errors.downloadType)} onChange={handleChange}/>

      {disabled && (<ReasonContainer>
          <Typography $fontSize="small" $appearance="300" $fontWeight="semibold">
            <Trans comment="Download document dialog - Download unavailable title">DOCX download unavailable</Trans>
          </Typography>

          <Typography $fontSize="small" $appearance="200">
            {pleditorDownloadUnavailable && (<Trans comment="Download document dialog - Download unavailable - Pleditor import/export not available">
                Downloading as a DOCX file is not available on your current plan (paid feature). To enable this, please
                contact support. Note that you can still download te document as PDF.
              </Trans>)}

            {lockedReason && getLockedReasonMessage(lockedReason)}
          </Typography>

          {pleditorDownloadUnavailable && (<Button as="a" appearance="secondary" size="xs" href={contact} target="_blank" rel="noopener noreferrer">
              <Trans context="Download document dialog" comment="Download unavailable - Pleditor import/export not available - Button label">
                Contact support
              </Trans>
            </Button>)}
        </ReasonContainer>)}
    </Box>);
}
